import h from "./index.es119.js";
import L from "./index.es336.js";
import O from "./index.es240.js";
import n from "./index.es130.js";
import N from "./index.es125.js";
import U from "./index.es337.js";
import C from "./index.es242.js";
import x from "./index.es133.js";
import { progressEventReducer as v } from "./index.es338.js";
import k from "./index.es339.js";
const q = typeof XMLHttpRequest < "u", Q = q && function(r) {
  return new Promise(function(y, a) {
    const t = k(r);
    let c = t.data;
    const f = x.from(t.headers).normalize();
    let { responseType: l, onUploadProgress: E, onDownloadProgress: T } = t, i, g, R, d, p;
    function w() {
      d && d(), p && p(), t.cancelToken && t.cancelToken.unsubscribe(i), t.signal && t.signal.removeEventListener("abort", i);
    }
    let e = new XMLHttpRequest();
    e.open(t.method.toUpperCase(), t.url, !0), e.timeout = t.timeout;
    function b() {
      if (!e)
        return;
      const o = x.from(
        "getAllResponseHeaders" in e && e.getAllResponseHeaders()
      ), s = {
        data: !l || l === "text" || l === "json" ? e.responseText : e.response,
        status: e.status,
        statusText: e.statusText,
        headers: o,
        config: r,
        request: e
      };
      L(function(u) {
        y(u), w();
      }, function(u) {
        a(u), w();
      }, s), e = null;
    }
    "onloadend" in e ? e.onloadend = b : e.onreadystatechange = function() {
      !e || e.readyState !== 4 || e.status === 0 && !(e.responseURL && e.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, e.onabort = function() {
      e && (a(new n("Request aborted", n.ECONNABORTED, r, e)), e = null);
    }, e.onerror = function(o) {
      const s = o && o.message ? o.message : "Network Error", u = new n(s, n.ERR_NETWORK, r, e);
      u.event = o || null, a(u), e = null;
    }, e.ontimeout = function() {
      let o = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const s = t.transitional || O;
      t.timeoutErrorMessage && (o = t.timeoutErrorMessage), a(new n(
        o,
        s.clarifyTimeoutError ? n.ETIMEDOUT : n.ECONNABORTED,
        r,
        e
      )), e = null;
    }, c === void 0 && f.setContentType(null), "setRequestHeader" in e && h.forEach(f.toJSON(), function(o, s) {
      e.setRequestHeader(s, o);
    }), h.isUndefined(t.withCredentials) || (e.withCredentials = !!t.withCredentials), l && l !== "json" && (e.responseType = t.responseType), T && ([R, p] = v(T, !0), e.addEventListener("progress", R)), E && e.upload && ([g, d] = v(E), e.upload.addEventListener("progress", g), e.upload.addEventListener("loadend", d)), (t.cancelToken || t.signal) && (i = (o) => {
      e && (a(!o || o.type ? new N(null, r, e) : o), e.abort(), e = null);
    }, t.cancelToken && t.cancelToken.subscribe(i), t.signal && (t.signal.aborted ? i() : t.signal.addEventListener("abort", i)));
    const m = U(t.url);
    if (m && C.protocols.indexOf(m) === -1) {
      a(new n("Unsupported protocol " + m + ":", n.ERR_BAD_REQUEST, r));
      return;
    }
    e.send(c || null);
  });
};
export {
  Q as default
};
//# sourceMappingURL=index.es245.js.map
